import React from "react";
import OrderDetailTopCardSkeleton from "./OrderDetailTopCardSkeleton";
import OrderStatusDetailCardSkeleton from "./OrderStatusDetailCardSkeleton";
import ProgressIndicatorCardSkeleton from "./ProgressIndicatorCardSkeleton";

const OrderDetailSkeleton = () => {
  return (
    <div className="flex flex-col lg:flex-row lg:gap-[2.875rem]">
      {/* Main Content */}
      <div className="flex flex-col flex-1 gap-3 h-fit">
        <div className="flex flex-col space-x-2 space-y-2 md:flex-row md:space-y-0 lg:space-x-0">
          {/* Top Card Skeleton*/}
          <OrderDetailTopCardSkeleton />
          {/* Mobile Progress Indicator */}
          <div className="block mt-6 lg:mt-0 lg:hidden">
            <ProgressIndicatorCardSkeleton />
          </div>
        </div>

        {/* Bottom Card */}
        <div className="px-4 sm:px-6 pt-8 pb-12 bg-white rounded-[1.25rem] border border-light-blue">
          <div className="w-32 h-8 mb-6 bg-gray-200 rounded"></div>
          <div className="flex flex-col gap-6 ">
            {[...Array(3)].map((_, index) => (
              <OrderStatusDetailCardSkeleton key={index} />
            ))}
          </div>
        </div>
      </div>
      {/* Desktop Progress Indicator */}
      <div className="hidden mt-6 lg:mt-0 lg:block">
        <ProgressIndicatorCardSkeleton />
      </div>
    </div>
  );
};

export default OrderDetailSkeleton;
